<template>
  <div>
    <div v-for="page in pages" :key="page">
      <p class="onetitle">出 仓 单</p>
      <div class="form-logo">
        <div><img :src="form.logoUrl" alt=""></div>
        <div>
          <div style="font-size: normal">
            {{ form.fCompany }}
          </div>
          <div
            style="
              font-size: 12px;
              -webkit-transform: scale(0.7);
              -webkit-transform-origin-x: 0;
            "
          >
            {{ form.fCompanyEnglish }}
          </div>
        </div>
      </div>
      <div class="form-info">
        <div>提货部门：{{ form.fBillingName }}</div>
        <div>
          客户名称：{{ form.fCustomer }}
          <span>NO：{{ form.fBillNo }}</span>
          <span>日期：{{ fmtDateTime(form.fCreateTime) }}</span>
        </div>
      </div>
      <table class="form-table">
        <thead>
          <tr>
            <th>产品编号</th>
            <th>品名</th>
            <th>规格</th>
            <th>单位</th>
            <th>数量</th>
            <th>生产日期</th>
            <th>生产批号</th>
            <th>消毒日期</th>
            <th>发货日期</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="x in items(page)" :key="x.fNumber">
            <td>{{ x.fNumber }}</td>
            <td>{{ x.fName }}</td>
            <td>{{ x.fModel }}</td>
            <td>{{ x.fUnit }}</td>
            <td>{{ x.fQty }}</td>
            <td>{{ x.fDate_Sc }}</td>
            <td>{{ x.fBatchNo }}</td>
            <td>{{ x.fDate_Xd }}</td>
            <td>{{ x.fDate_fh }}</td>
            <td>{{ x.fDes }}</td>
          </tr>
          <tr>
            <td rowspan="2">备注</td>
            <td colspan="9">{{ form.des1 }}</td>
          </tr>
          <tr>
            <td colspan="9">{{ form.des2 }}</td>
          </tr>
        </tbody>
      </table>
      <div class="form-foot">
        <span>记账：{{ form.jz }}</span>
        <span>会计：{{ form.kj }}</span>
        <span>出纳：{{ form.cn }}</span>
        <span>部门主管：{{ form.bmzg }}</span>
        <span>保管：{{ form.bg }}</span>
        <span>提货人：{{ form.thr }}</span>
      </div>
      <div style="text-align: center;margin-top:5px; page-break-after: always">
        <div>{{ page + 1 }}/{{ pages.length }}</div>
        <div><span style="float: right; font-weight: bold; font-size: 14px">
          {{ form.fControlledNumber }}
        </span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  data: function() {
    return {
      form: {
        stockEntrys: []
      },
      loading: false,
      pageSize: 5
    }
  },
  computed: {
    pages: function() {
      var count = Math.ceil(this.form.stockEntrys.length / this.pageSize)
      var rtn = []
      for (let i = 0; i < count; i++) {
        rtn.push(i)
      }
      // console.log('pages', rtn);
      return rtn
    }
  },
  methods: {
    refresh: async function(fid) {
      this.loading = true
      const res = await this.$httpPost('OrderManage/Order/OutStockPrint', {
        fid: fid
      }).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist
      return true
    },
    items: function(page) {
      var rtn = []
      for (let i = 0; i < this.pageSize; i++) {
        const itemIdx = page * this.pageSize + i
        if (itemIdx >= this.form.stockEntrys.length) break
        const item = this.form.stockEntrys[itemIdx]
        rtn.push(item)
      }
      // console.log('items', page, rtn);
      return rtn
    },
    fmtDateTime: function(dt) {
      var m = moment(dt, 'YYYY-MM-DD HH:mm:ss')
      return m.format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.onetitle {
  font-weight: bold;
  font-size: 25px;
  font-family: 华文行楷;
  text-align: center;
  margin: 0;
}

.form-logo {
  display: flex;
  align-items: center;
}

.form-info {
  font-size: 14px;
  margin-bottom: 5px;
  span {
    float: right;
    margin-left: 35px;
  }
}

.form-table {
  width: 100%;
  border-collapse: collapse;
}

.form-table,
td,
th {
  border: 1px solid black;
  font-size: small;
}

.form-foot {
  display: flex;
  font-size: 14px;
  margin-top: 5px;
  span {
    flex: 1;
    justify-content: space-between;
  }
}
</style>

